import { render } from "./ChooseTemplate.vue?vue&type=template&id=c2f66448"
import script from "./ChooseTemplate.vue?vue&type=script&lang=js"
export * from "./ChooseTemplate.vue?vue&type=script&lang=js"

import "./ChooseTemplate.vue?vue&type=style&index=0&id=c2f66448&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__